import TPagination from 'vue-tailwind/src/components/TPagination.vue'
import TDropdown from 'vue-tailwind/src/components/TDropdown.vue'
import TAlert from 'vue-tailwind/src/components/TAlert.vue'

export function initTailwindVue (vue): void {
  vue.use(TPagination, {
    wrapperClass: 'table border-collapse bg-gray-400 rounded',
    controlClass: 'w-6 h-7',
    disabledControlClass: 'w-6 h-7',
    buttonClass: 'flex w-full h-full items-center justify-center font-bold text-xl',
    controlButtonClass: 'text-gray-800 hover:bg-gray-600',
    disabledControlButtonClass: 'text-gray-500 cursor-not-allowed',
  })
  vue.use(TDropdown, {
    dropdownClass: 'flex flex-col bg-white text-gray-500 border shadow-md z-10 rounded-md',
  })
  vue.use(TAlert, {
    baseClass: 'fixed flex text-white bottom-0 w-full px-5 py-3',
    infoClass: 'bg-gray-700',
    successClass: 'bg-green',
    dangerClass: 'bg-orange',
    closeButtonClass: 'absolute top-0 bottom-0 right-0 px-4 py-3 flex items-center',
    closeIconClass: 'fill-current h-5 w-5',
  })
}
